import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NCashDataUtil} from '../../../../utils/finzy-flex/nCash-data.util';
import { AttributeCode, AttributeValue, InvestmentPreference, nCashFrequencies, nCashDates, UserAttribute } from '../../../../model/finzy-flex/user-attribute.model';

@Component({
  selector: 'app-interest-only-n-cash-attribute',
  templateUrl: './interest-only-n-cash-attribute.component.html',
  styleUrls: ['./interest-only-n-cash-attribute.component.scss']
})
export class InterestOnlyNCashAttributeComponent implements OnInit {
  private nCashDataUtil: NCashDataUtil;
  public frequencies = nCashFrequencies;
  public dates = nCashDates;
  public currentFrequency: number | AttributeValue;
  public currentDate: number | AttributeValue;
  public interestOnlyAmount: number = 0;

  @Input()
  userAttributes: InvestmentPreference[];

  @Input()
  userAttributesForm: FormGroup;

  @Input()
  havePreferencesChanged: any;

  @Input()
  previousUserAttribute: UserAttribute;

  @Output()
  changeValue: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  userAttributesSwiftForm: FormGroup

  @Input()
  isSwiftEnabled: boolean

  @Input()
  backupSwiftAttribute: InvestmentPreference[] = []

  constructor(nCashDataUtil: NCashDataUtil) {
    this.nCashDataUtil = nCashDataUtil;
  }

  ngOnInit(): void {
    this.currentFrequency = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue;
    this.currentDate = this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue;
    this.onAttributeChange();
  }

  public onFrequencyChange() {
    this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue = this.currentFrequency;
    this.onAttributeChange();
    this.changeValue.emit(this.havePreferencesChanged());
  }

  public onDateChange() {
    this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue = this.currentDate;
    this.onAttributeChange();
    this.changeValue.emit(this.havePreferencesChanged());
  }

  private async onAttributeChange() {
    if (this.currentDate && this.currentFrequency) {
      await this.nCashDataUtil.getNCashDetailsByLenderId(AttributeValue.INTEREST_ONLY, this.currentFrequency.toString(), Number(this.currentDate))
        .then(nCashData => this.interestOnlyAmount = nCashData.status === 0 ? nCashData.data[0].ncashAmount : 0)
        .catch(() => this.interestOnlyAmount = 0);
    } else {
      this.interestOnlyAmount = 0;
    }
  }
}
